module.exports = __webpack_public_path__ + "img/food4.c9825cc5.webp";